"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var datapoints_1 = require("./datapoints");
exports.datapoints = datapoints_1.default;
owa_bundling_1.preloadScriptChunk('MailMessageActions');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "MailMessageActions" */ './lazyIndex');
});
exports.lazyNewMessage = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.newMessage; });
exports.lazyReplyToConversation = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.replyToConversation; });
exports.lazyForwardConversation = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.forwardConversation; });
exports.lazyPrintConversation = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.printConversation; });
exports.lazyReplyToItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.replyToItem; });
exports.lazyForwardItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.forwardItem; });
exports.lazyPrintItem = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.printItem; });
exports.lazyShowConversationInImmersiveReader = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.showConversationInImmersiveReader; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-message-actions/lib/index.js
// module id = 689
// module chunks = 4 46 93 105 108